import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Button, Card, List, message, Modal } from 'antd';
import { ExclamationCircleOutlined, LeftOutlined } from '@ant-design/icons';
import { useHistory, useParams } from 'react-router-dom';
import { axiosInstance, BASE_API_CONFIG } from '../../util/Api';
import { formatDate } from '../../util/helper';
import RFQStatusTags from '../requestQuotation/RFQStatus';
import { BUSINESS_REQUEST_STATUS, BusinessRequestStatusTags } from '../../util/Constant';

const BusinessCardRequestsViewDetails = () => {
    const history = useHistory();
    const { id } = useParams();
    const [details, setDetails] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchDetails();
    }, [id]);

    const fetchDetails = async () => {
        try {
            const response = await axiosInstance.get(
                `${BASE_API_CONFIG.baseURL}/business-card-request/${id}`
            );
            setDetails(response.data);

        } catch (error) {
            console.error('Error fetching details:', error);
        } finally {
            setLoading(false);
        }
    };

    const updateStatus = async (id,status, forwarderName) => {
        try{
            await axiosInstance.patch(
              `${BASE_API_CONFIG.baseURL}/business-card-request/${id}/status`,
               { status }
            );
            message.success(
                      `Request from ${forwarderName} ${status.toLowerCase()} successfully!`
            );
           fetchDetails(); 
        } catch (error) {
            message.error(
                error?.response?.data?.message || `Failed to ${status.toLowerCase()} request`
            )
        }
    };

    const handleApprove = useCallback((record) => {
        Modal.confirm({
            title: "Approve Business Card Request",
            icon: <ExclamationCircleOutlined/>,
            content: `Are you sure you want to approve the request from ${record?.forwarder?.companyName}?`,
            okText: "Yes",
            cancelText: "NO",
            onOk: async () => {
                await updateStatus(record?.id,BUSINESS_REQUEST_STATUS.APPROVED,record?.forwarder?.companyName,  )
            },
        });
    },[]);

      const handleReject = useCallback((record) => {
        Modal.confirm({
          title: "Reject Business Card Request",
          icon: <ExclamationCircleOutlined />,
          content: `Are you sure you want to reject the request from ${record?.forwarder?.companyName}`,
          okText: "Yes",
          cancelText: "No",
          okButtonProps: { danger: true },
          onOk: async () => {
            await updateStatus(record?.id,BUSINESS_REQUEST_STATUS.REJECTED,record?.forwarder?.companyName);
          },
        });
      }, []);



    const data = useMemo(() => {
        if (!details) return [];

        return [
            {
                label: "Received Date",
                value: formatDate(details.createdAt),
            },
            {
                label: "Company Name",
                value: (
                    <div>
                        {details.forwarder?.companyName} &nbsp;&nbsp;{" "}
                        <span
                            onClick={() => navigateBusinessCard(details?.forwarder.id)}
                            className={"myexim-link"}>
                            View Profile
                        </span>
                    </div>
                ),
            },
            {
                label: "Comments",
                value: details?.comments || "-",
            },
            {
                label: "Status",
                value: details?.status
            },
        ];
    }, [details]);

    const navigateBusinessCard = (id) => {
        if (id) {
            history.push({
                pathname: '/user-profile',
                search: `?id=${id}`
            });
        }
    };
    const handleButton = details?.status === BUSINESS_REQUEST_STATUS.PENDING

    return (
        <>
            <Card className="myexim-detail-card" loading={loading}>
                <div className="myexim-table-title">
                    <LeftOutlined
                        size="large"
                        onClick={() => {
                            history.goBack();
                        }}
                        style={{ cursor: 'pointer', marginRight: '12px' }}
                    />
                    Business Card Request Details
                </div>
                {details && <div className="gx-pl-4">
                    <List
                        className="gx-mt-4"
                        itemLayout="horizontal"
                        dataSource={data}
                        renderItem={(item) =>
                            item?.value && (
                                <List.Item className="myexim-details-list">
                                    <List.Item.Meta
                                        title={<div>{item.label}</div>}
                                        description={item.value}
                                    />
                                </List.Item>
                            )
                        }
                    />
                    {
                        handleButton && (
                    <div
                        style={{ justifyContent: "center", display: "flex", flex: 1 }}
                        className="gx-pt-4"
                    >
                        <Button
                            type="secondary"
                            size="large"
                            onClick={() => {
                            handleReject(details);
                            }}
                        >
                            REJECT
                        </Button>
                        <Button
                            type="primary"
                            size="large"
                            onClick={() => {
                            handleApprove(details);
                            }}
                        >
                            APPROVE
                        </Button>
                    </div>
                    )}   
                </div>
                }
            </Card>
        </>
    );
};

export default BusinessCardRequestsViewDetails;
